import { IconButton } from "@ui-lib/index"
import { useTranslation } from "react-i18next"
import { MdClose } from "react-icons/md"

export default function SeempInfoCard({
	setModalOpenState,
}: {
	setModalOpenState: (isOpen: boolean) => void
}) {
	const { t } = useTranslation()
	return (
		<div
			className={`shadow-card fixed inset-1/2 m-4 flex h-150 w-225 -translate-1/2 flex-col items-center justify-items-start rounded-sm border-0 bg-white`}
		>
			<div className={`flew-row relative flex w-full items-center justify-center py-2`}>
				<p className={`text-headline text-dipai-text-primary font-semibold`}>
					{t(`${"SEEMP REPORT VIDEO DEMONSTRATION"}`)}
				</p>
				<div className="absolute top-2.5 right-2 ml-auto">
					<IconButton
						variant={"text-dark"}
						size={"sm"}
						onClick={() => setModalOpenState(false)}
					>
						<IconButton.Icon>{MdClose}</IconButton.Icon>
					</IconButton>
				</div>
			</div>

			<div className="h-145 w-200 rounded-sm bg-black p-4">
				<iframe
					width="100%"
					height="100%"
					src="https://www.youtube.com/embed/kulBrIMsWbg"
					title={t("SEEMP REPORT VIDEO DEMONSTRATION")}
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
				/>
			</div>
			<p className="text-menu text-dipai-text-primary my-2 h-12.5 w-200 text-justify">
				{t(
					"THE DEFAULT ACTIONS AVAILABLE FOR UNISEA VESSELS IS LIMITED DUE TO LACK OF SENSOR DATA."
				)}
			</p>
		</div>
	)
}
